import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import settingConfirmationListItemStyles from "../styles/SettingConfirmationListItem.styles";

const SettingConfirmationListItem = ({ section = "", changes = [] }) => {
	const classes = settingConfirmationListItemStyles();

	return (
		<>
			<ListItem dense>
				<ListItemText
					primaryTypographyProps={{
						className: classes.sectionText
					}}
					primary={section}
				/>
			</ListItem>
			<List className={classes.changeList} disablePadding>
				{changes.map((change) => (
					<ListItem dense>
						<ListItemText primary={change.setting} secondary={change.message} />
					</ListItem>
				))}
			</List>
		</>
	);
};
export default SettingConfirmationListItem;
